// Homepage videos + blog (#185, Yuri 10-09): the scroll-in reveal, and on mobile the videos and blog lists become a
// horizontal row; this adds Instagram-style ‹ › buttons and dots. Each [data-rail] holds
// the list (.vids / .posts), [data-rail-prev] / [data-rail-next] and [data-rail-dots].
// On desktop the list doesn't overflow, so the controls stay hidden (CSS) and inert.
(function () {
  if (window.fstvHomeRail) return;
  window.fstvHomeRail = true;

  function init(rail) {
    var list = rail.querySelector('.vids, .posts');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');
    var dots = rail.querySelector('[data-rail-dots]');
    if (!list || !prev || !next || !dots) return;
    var items = Array.prototype.slice.call(list.children);
    if (items.length < 2) return;

    dots.replaceChildren.apply(dots, items.map(function () { return document.createElement('span'); }));
    rail.classList.add('has-rail');

    function current() {
      var x = list.scrollLeft, best = 0, d = Infinity;
      items.forEach(function (it, i) {
        var dd = Math.abs(it.offsetLeft - list.offsetLeft - parseFloat(getComputedStyle(list).paddingLeft) - x);
        if (dd < d) { d = dd; best = i; }
      });
      return best;
    }
    function go(i) {
      var it = items[Math.max(0, Math.min(items.length - 1, i))];
      list.scrollTo({ left: it.offsetLeft - list.offsetLeft - parseFloat(getComputedStyle(list).paddingLeft), behavior: 'smooth' });
    }
    function update() {
      var i = current();
      var end = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      prev.disabled = i === 0;
      next.disabled = end || i === items.length - 1;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === (end ? items.length - 1 : i)); });
      // Centre the buttons on the picture, not on the whole card.
      var media = items[0].querySelector('.vid-play, .post-img, .post-title');
      if (media) rail.style.setProperty('--rail-y', (media.offsetTop + media.offsetHeight / 2) + 'px');
    }
    prev.addEventListener('click', function () { go(current() - 1); });
    next.addEventListener('click', function () { go(current() + 1); });
    var t;
    list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Scroll-in reveal, the testimonials' pattern (#184): the section gets .is-visible once
  // 12 % of it is on screen, and the CSS rises the heading then each card in turn.
  // Without JS or IntersectionObserver nothing is hidden.
  function reveal(sec) {
    if (!('IntersectionObserver' in window)) { sec.classList.add('is-visible'); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { sec.classList.add('is-visible'); io.disconnect(); }
    }, { threshold: 0.12 });
    io.observe(sec);
  }

  function all() {
    document.querySelectorAll('[data-rail]').forEach(init);
    document.querySelectorAll('.fstv-home.videos, .fstv-home.blog').forEach(reveal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
})();
